import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'login',
    meta: {
      IgnoreAuth: true,
    },
    component: () => import('@view/login')
  },
  /*------------------------------------------------------*/
  {
    path: '/index',
    name: 'index',
    component: () => import('@view/index'),
    redirect: '/index/main',
    children: [
      {
        path: '/index/main',
        name: '首页',
        component: () => import('@view/index/main')
      },
      {
        path: '/index/chat/index',
        name: '在线客服',
        component: () => import('@view/chat/index')
      },
      {
        path: '/index/menu/list',
        name: '菜单管理',
        component: () => import('@view/sys/menu/list')
      },
      {
        path: '/index/user/group',
        name: '权限管理',
        component: () => import('@view/sys/user/group')
      },
      {
        path: '/index/user/list',
        name: '账号管理',
        component: () => import('@view/sys/user/list')
      },
      {
        path: '/index/report/list',
        name: '下载中心',
        component: () => import('@view/sys/report/list')
      },
      {
        path: '/index/user/add',
        name: '添加账号',
        component: () => import('@view/sys/user/add')
      },
      //用户管理
      {
        path: '/index/userMember/list',
        name: '用户管理',
        component: () => import('@view/user/list')
      },
      {
        path: '/index/userMember/detail',
        name: '用户详情',
        component: () => import('@view/user/detail')
      },
      {
        path: '/index/user/set',
        name: '会员设置',
        component: () => import('@view/user/set')
      },
      {
        path: '/index/franchisee/list',
        name: '加盟商管理',
        component: () => import('@view/franchisee/list')
      },
      {
        path: '/index/franchisee/audit',
        name: '加盟商审核',
        component: () => import('@view/franchisee/audit')
      },
      {
        path: '/index/shop/audit/detail',
        name: '审核信息',
        component: () => import('@view/components/shop/audit-detail')
      },
      {
        path: '/index/franchisee/add',
        name: '添加加盟商',
        component: () => import('@view/franchisee/add')
      },
      {
        path: '/index/franchisee/detail',
        name: '加盟商详情',
        component: () => import('@view/franchisee/detail')
      },
      {
        path: '/index/store/list',
        name: '实体店管理',
        component: () => import('@view/store/list')
      },
      {
        path: '/index/store/audit',
        name: '实体店审核',
        component: () => import('@view/store/audit')
      },
      {
        path: '/index/store/add',
        name: '编辑实体店',
        component: () => import('@view/store/add')
      },
      {
        path: '/index/store/detail',
        name: '实体店详情',
        component: () => import('@view/store/detail')
      },
      /**-------------------商城管理--------------------**/
      {
        path: '/index/shop/goods',
        name: '商品管理',
        meta: {
          keepAlive: true,
        },
        component: () => import('@view/shop/goods')
      },
      {
        path: '/index/shop/audit',
        name: '商品审核',
        meta: {
          keepAlive: true,
        },
        component: () => import('@view/shop/audit')
      },
      {
        path: '/index/shop/goods/detail',
        name: '商品详情',
        component: () => import('@view/shop/op/goods-detail')
      },
      {
        path: '/index/shop/classify',
        name: '分类管理',
        component: () => import('@view/shop/classify')
      },
      {
        path: '/index/shop/brand',
        name: '品牌管理',
        component: () => import('@view/shop/brand')
      },
      /**-------------------商城订单--------------------**/
      {
        path: '/index/order/logistics',
        name: '物流公司管理',
        component: () => import('@view/order/logistics')
      },
      {
        path: '/index/order/order',
        name: '商城订单管理',
        component: () => import('@view/order/order')
      },
      {
        path: '/index/order/refund',
        name: '商城售后管理',
        meta: {
          keepAlive: true,
        },
        component: () => import('@view/order/refund')
      },
      /**-------------------租赁管理--------------------**/
      {
        path: '/index/lease/goods',
        name: '租售商品管理',
        meta: {
          keepAlive: true,
        },
        component: () => import('@view/lease/goods')
      },
      {
        path: '/index/lease/repair',
        name: '故障维修管理',
        meta: {
          keepAlive: true,
        },
        component: () => import('@view/lease/repair/list')
      },
      {
        path: '/index/lease/repair/detail',
        name: '故障维修详情',
        component: () => import('@view/lease/repair/detail')
      },
      {
        path: '/index/lease/goods/add',
        name: '添加租售商品管理',
        component: () => import('@view/lease/op/goods-add.vue')
      },
      {
        path: '/index/lease/classify',
        name: '租售分类管理',
        component: () => import('@view/lease/classify')
      },
      {
        path: '/index/lease/brand',
        name: '租售品牌管理',
        component: () => import('@view/lease/brand')
      },
      {
        path: '/index/lease/freight',
        name: '租售运费模板',
        component: () => import('@view/lease/freight')
      },
      {
        path: '/index/freight/add',
        name: '编辑运费模板',
        component: () => import('@view/components/freight/freight-add.vue')
      },
      {
        path: '/index/lease/contract',
        name: '租赁合同管理',
        component: () => import('@view/lease/contract')
      },
      {
        path: '/index/lease/contract/add',
        name: '租赁合同编辑',
        component: () => import('@view/lease/contract/contract-add.vue')
      },
      {
        path: '/index/lease/contract/detail',
        name: '查看租赁合同',
        component: () => import('@view/lease/contract/contract-detail.vue')
      },
      {
        path: '/index/lease/order',
        name: '租售订单管理',
        component: () => import('@view/lease/order')
      },
      {
        path: '/index/order/detail',
        name: '订单详情',
        component: () => import('@view/components/order/order-detail.vue')
      },
      {
        path: '/index/lease/refund',
        name: '售后管理',
        meta: {
          keepAlive: true,
        },
        component: () => import('@view/lease/refund')
      },
      {
        path: '/index/refund/detail',
        name: '售后详情',
        component: () => import('@view/components/order/refund-detail.vue')
      },
      {
        path: '/index/lease/questionnaire',
        name: '调查问卷',
        component: () => import('@view/lease/questionnaire.vue')
      },
      {
        path: '/index/lease/questionnaire/detail',
        name: '调查问卷详情',
        component: () => import('@view/lease/questionnaire/detail.vue')
      },
      /**-------------------营销管理--------------------**/
      {
        path: '/index/sales/coupon',
        name: '优惠券管理',
        component: () => import('@view/sales/coupon/list')
      },
      {
        path: '/index/sales/coupon/add',
        name: '编辑优惠券',
        component: () => import('@view/sales/coupon/add')
      },
      {
        path: '/index/sales/coupon/detail',
        name: '查看优惠券',
        component: () => import('@view/sales/coupon/detail')
      },
      {
        path: '/index/sales/activity',
        name: '活动专区',
        component: () => import('@view/sales/activity/list')
      },
      {
        path: '/index/sales/news',
        name: '今日上新',
        component: () => import('@view/sales/activity/news')
      },
      /**-------------------财务管理--------------------**/
      {
        path: '/index/finance/money',
        name: '平台流水',
        component: () => import('@view/finance/money')
      },
      {
        path: '/index/finance/set',
        name: '分账规则',
        component: () => import('@view/finance/set')
      },
      {
        path: '/index/finance/withdraw',
        name: '提现管理',
        component: () => import('@view/finance/withdraw')
      },
      /**-------------------内容管理--------------------**/
      {
        path: '/index/content/about',
        name: '关于我们',
        component: () => import('@view/content/about')
      },
      {
        path: '/index/content/help',
        name: '帮助中心',
        component: () => import('@view/content/help')
      },
      {
        path: '/index/content/feedback',
        name: '意见反馈',
        component: () => import('@view/content/feedback')
      },
      {
        path: '/index/content/agree',
        name: '隐私政策',
        component: () => import('@view/content/agree')
      },
      {
        path: '/index/content/banner',
        name: '轮播图管理',
        component: () => import('@view/content/banner')
      },
      {
        path: '/index/content/banner/add',
        name: '编辑轮播图',
        component: () => import('@view/content/op/banner-add')
      },
      /**-------------------商家管理端功能--------------------**/
      /**----------门店管理-------------**/
      {
        path: '/index/org/shop/info',
        name: '加盟商信息',
        component: () => import('@org/shop/info')
      },
      {
        path: '/index/org/shop/base',
        name: '加盟商基础信息',
        component: () => import('@org/shop/base')
      },
      /**----------商品管理-------------**/
      {
        path: '/index/org/goods/list',
        name: '加盟商商品管理',
        meta: {
          keepAlive: true,
        },
        component: () => import('@org/goods/list')
      },
      {
        path: '/index/org/goods/freight',
        name: '加盟商运费模板',
        component: () => import('@org/goods/freight')
      },
      {
        path: '/index/org/goods/edit',
        name: '加盟商商品编辑',
        component: () => import('@org/goods/op/goods-edit')
      },
      /**----------订单管理-------------**/
      {
        path: '/index/org/order/list',
        name: '加盟商订单管理',
        component: () => import('@org/order/list')
      },
      {
        path: '/index/org/order/refund',
        name: '加盟商售后管理',
        component: () => import('@org/order/refund')
      },
      /**----------财务管理-------------**/
      {
        path: '/index/org/finance/list',
        name: '加盟商财务管理',
        component: () => import('@org/finance/list')
      },
      {
        path: '/index/org/finance/withdraw',
        name: '加盟商提现管理',
        component: () => import('@org/finance/withdraw')
      },
      {
        path: '/index/org/finance/bankList',
        name: '加盟商银行卡管理',
        component: () => import('@org/finance/bankList')
      },
      /**----------客户管理-------------**/
      {
        path: '/index/org/customer/list',
        name: '加盟商客户管理',
        component: () => import('@org/customer/list')
      },
      {
        path: '/index/org/customer/detail',
        name: '加盟商客户详情',
        component: () => import('@org/customer/detail')
      },
      /**-------------------商家管理端功能End--------------------**/
    ]
  }
]
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
//
router.beforeEach((to, from, next) => {
  let that = router.app
  //控制登录如果有忽略就直接跳转
  if (to.matched.length === 0) {
    if(to.path=='/index/authToken'){
      let token = that.getUrlKey2("token");
      if(token){
        localStorage.setItem("qc_token",token);
        localStorage.removeItem("index");
        that.$store.commit("addIndex","");
        that.$router.push({path: '/index/main'});
      }
    }else{
      //如果未匹配到路由
      that.$message({
        type: 'error',
        message: '正在建设中.....'
      })
    }
  } else if (to.meta.IgnoreAuth) {
    next()
  } else {
    if (!that.$store.state.user.routerMap) {
      that.simplePost('/api/mgr/login/getLoginUser', null, result => {
        if (result.data.status == 1) {
          that.msgAlert('此账号被禁用，请联系管理员！！！',
            () => {
              localStorage.removeItem('qc_token')
              that.$router.push({ path: '/' })
            })
        }else if (result.data.source == 3) {
          that.msgAlert('门店用户请前往小程序登录',
            () => {
              localStorage.removeItem('qc_token')
              that.$router.push({ path: '/' })
            })
        }else {
          if(result.data.source == 2){
            //加盟商登录 提前注册IM
            that.simplePost("/api/mgr/business/shop/info/getUserSig",null,res=>{},false);
          }
          that.$store.commit('addUser', result.data);
          source = result.data.source;
        }
      }, false)
    }
    next()
  }
})
export default router
